import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router'

import { Spinner } from '@ui/components/loaders'
import { SignupPageStatus } from '@ui/interfaces'
import { useAuth } from '@ui/providers/AuthProvider'

type LoginFormProps = {
  setPageStatus: (status: SignupPageStatus) => void
  setMessage: (message: string) => void
}

export function ConfirmEmail(props: LoginFormProps) {
  const { setPageStatus, setMessage } = props
  const navigate = useNavigate()
  const auth = useAuth()

  const { token } = useParams()

  const [waiting, setWaiting] = useState(false)
  const [searchParams] = useSearchParams()

  const isDemo: boolean = searchParams?.get('d') === 'true'
  const demoInstanceConnectKey = searchParams?.get('di')

  const sendToServer = ({ token }: { token: string }) => {
    if (!token) {
      console.error('no token found')
      return
    }

    setWaiting(true)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    auth.confirmEmail(token, isDemo, (error: any) => {
      setWaiting(false)

      if (error) {
        const { response } = error
        // Error is an object with key and value as strings.

        if (response) {
          // For non-validation errors (e.g., 500 Internal Server Error), you can set a global error
          // This could be a state in your component to show the error message
          setMessage('Something went wrong confirming your email address.')
          setPageStatus(SignupPageStatus.FAIL) // Or any other way you handle global errors
        }
      } else {
        setTimeout(() => {
          if (isDemo === true && demoInstanceConnectKey) {
            auth.restoreSession(() => {
              navigate(`/instances/${demoInstanceConnectKey}/explore/events`)
            })
          } else {
            navigate(`/organizations?setup=true`)
          }
        }, 2000)
      }
    })
  }

  let hasUpdated = false
  useEffect(() => {
    if (hasUpdated || !token || token === '') return

    sendToServer({ token: token as string })
    hasUpdated = true
  }, [token])

  return (
    <div className={'h-fit w-full py-10'}>
      {waiting && <Spinner />}
      {!waiting && (
        <div className="space-y-2">
          <h1 className="text-center text-3xl font-medium text-gray-800">Welcome!</h1>
          <p className="text-center text-sm text-gray-600">
            Your account has been successfully created. Let&apos;s get you started.
          </p>
        </div>
      )}
    </div>
  )
}
